var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-wrapper",on:{"mouseover":function($event){_vm.showTooltip = true},"mouseleave":function($event){_vm.showTooltip = false}}},[_vm._t("default"),(_vm.showTooltip && _vm.text)?_c('div',{staticClass:"custom-tooltip"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }